import { i18nPath } from 'config/i18nNs';
import useTabs from 'hooks/useTabs';
import TextBlock from 'layout/TextBlock';
import React from 'react';

export interface PolicyMainProps {
  sections: Array<{
    anchor: string;
    title: string;
    content: string;
    listActivities?: boolean;
  }>;
  activities: Array<{ [key: string]: string }>;
  cookieTypes: Array<{ [key: string]: string }>;
  pageIndex: number;
}

const PolicyMain: React.FC<PolicyMainProps> = ({
  sections = [],
  activities,
  cookieTypes,
  pageIndex
}) => {
  const { setActiveTab } = useTabs();

  return (
    <div>
      {sections &&
        sections.map((section, index) => (
          <TextBlock
            key={section.title}
            sectionI18nKey={`${i18nPath.policyPages}.${pageIndex}.sections.${index}`}
            index={index}
            setActiveTab={setActiveTab}
            activities={activities}
            cookieTypes={cookieTypes}
          />
        ))}
    </div>
  );
};

export default PolicyMain;
